import { Controller } from '@hotwired/stimulus';
import {
  AutoFormatOptions,
  Blocks,
  DEFAULT_TEMPLATE,
  DateParts,
  Pattern,
  defaultAutoFormatOptions,
  formatDateInput,
  getBlocks,
  parseISODate,
  toStrippedDateString,
} from '../../utilities/date';

export default class extends Controller {
  static readonly values = {
    template: String,
    date: String,
  };

  declare templateValue: string;
  declare dateValue: string;

  private formattedDate: string = '';
  private date: DateParts = {};
  private delimiter: string = '';
  private blocks: Blocks = [];
  private pattern: Pattern = [];

  initialize(): void {
    const options: AutoFormatOptions = {
      template: this.templateValue,
      value: this.element.innerHTML,
    };
    const { pattern, value, delimiter } = defaultAutoFormatOptions(
      options,
      DEFAULT_TEMPLATE,
    );
    this.pattern = pattern;
    this.formattedDate = value;
    this.delimiter = delimiter;
    this.blocks = getBlocks(pattern);
    if (this.dateValue) {
      const parts = parseISODate(this.dateValue);
      const strippedValue = toStrippedDateString({ parts, pattern });
      const { formattedDate, date } = formatDateInput({
        blocks: this.blocks,
        cursorPosition: 0,
        pattern: this.pattern,
        value: strippedValue,
        prevValue: strippedValue,
        delimiter: this.delimiter,
        prevDate: this.date,
      });
      this.date = date;
      this.formattedDate = formattedDate;
    }
    this.element.innerHTML = this.formattedDate;
  }
}
